<template>
    <ns-loader
        :fetch-timer="null"
        :to-load="toLoad"
        @dataFetched="onDataFetched"
    >
        <div slot="content">
            <div class="page-title">
                <div class="container">
                    <span class="icon icon-engine"></span>
                    <h1>{{pageTitle}}</h1>
                    <span
                        v-if="form.uid"
                        class="icon-bin"
                        @click="openDialog('engineDelete')"></span>
                </div>
            </div>
            <div class="advanced-form-container">
                <el-form
                    ref="form"
                    :model="form"
                    :rules="rules"
                    label-position="top"
                    class="moteurForm"
                >
                    <div class="top">
                        <el-row :gutter="24">
                            <el-col :xs="24" :sm="8">
                                <el-form-item
                                    label="Nom du moteur"
                                    prop="name"
                                    :show-message="showMessage('name')"
                                >
                                    <el-input
                                        v-model="form.name"
                                        :maxlength="15"
                                        required
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="8">
                                <el-form-item
                                    label="Description"
                                >
                                    <el-input
                                        class="formDesc"
                                        v-model="form.description"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="8" class="mode-switch">
                                <!-- <el-tooltip :content="tooltipContent" placement="top" effect="light"> -->
                                    <div 
                                        class="switch-labels inactive-label"
                                        :class="!isAdvanced?'is-active':''"
                                    >
                                        <span class="label-title">Mode Simple</span>
                                        <span class="label-descr">Sans calcul des économies d’énergie</span>
                                    </div>
                                    <el-switch
                                        :value="currentMode"
                                        active-value="advanced"
                                        inactive-value="simple"
                                        @click.native="beforeModeUpdate()"
                                    >
                                        <template #active-action>
                                            <span class="custom-active-action">T</span>
                                        </template>
                                    </el-switch>
                                    <div 
                                        class="switch-labels active-label"
                                        :class="isAdvanced?'is-active':''"
                                    >
                                        <span class="label-title">Mode Avancé</span>
                                        <span class="label-descr">Avec calcul des économies d’énergie</span>
                                    </div>
                                <!-- </el-tooltip> -->
                            </el-col>
                        </el-row>
                    </div>
                    <div class="advanced-form-content">
                        <PlaqueMoteurForm
                            :rules="rules"
                            :motor-form="form"
                            :is-advanced="isAdvanced"
                        ></PlaqueMoteurForm>
                        <DonneesForm
                            :rules="rules"
                            :motorForm="form"
                            :is-advanced="isAdvanced"
                        ></DonneesForm>
                        <TrainedMachineForm
                            v-if="isAdvanced"
                            :motor="form"
                            :form="form.trained_machine"
                        ></TrainedMachineForm>
                    </div>
                    <div class="buttons-container">
                        <el-button
                            class="whiteButton"
                            @click="cancel()"
                        >
                            Annuler
                        </el-button>
                        <div class="right">
                            <el-button
                                v-loading="loading"
                                type="primary"
                                class="right"
                                @click="saveEngine"
                            >
                                Valider
                            </el-button>
                        </div>
                    </div>
                </el-form>
            </div>
            <MwhPriceModal
                v-if="displayPriceModal"
                :dialog-visible="displayPriceModal"
                :site="relatedSite"
                @close="closePriceModal"
            ></MwhPriceModal>
        </div>
    </ns-loader>
</template>

<script>
import PlaqueMoteurForm from '@/components/partials/wizard/PlaqueMoteurForm.vue';
import DonneesForm from '@/components/partials/wizard/DonneesForm.vue';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader';
import {mapGetters} from 'vuex';
import TrainedMachineForm from '@/components/partials/wizard/TrainedMachineForm.vue';
import MwhPriceModal from '@/components/partials/wizard/MwhPriceModal.vue';

    export default {
        name:'AdvancedMotorForm',
        components:{
            PlaqueMoteurForm,
            DonneesForm,
            NsLoader,
            TrainedMachineForm,
            MwhPriceModal
        },
        data(){
            function checkNominalPower (rule, value, callback) {
                if (value > 9999 || value < 1) {
                    callback(new Error());
                } else {
                    callback();
                }
            }
            function checkNominalVoltage (rule, value, callback) {
                if (value > 400 || value < 380) {
                    callback(new Error());
                } else {
                    callback();
                }
            }
            function checkNominalIntensity (rule, value, callback) {
                if (value > 2000 || value < 3) {
                    callback(new Error());
                } else {
                    callback();
                }
            }
            function checkCosPhi (rule, value, callback) {
                if (value > 0.95 || value < 0.6) {
                    callback(new Error());
                } else {
                    callback();
                }
            }
            function checkNominalSpeed (rule, value, callback) {
                if ((value >= 1400 && value <= 1500) || (value >= 2900 && value <= 2999)) {
                    callback();
                } else {
                    callback(new Error());
                }
            }
            function checkWorkingTime (rule, value, callback) {
                if (value !== '') {
                    (value <= 8760 && value >= 0) ? callback() : callback(new Error());
                }
                callback(new Error());
            }
            function checkEfficiency (rule, value, callback) {
                if (value !== '') {
                    (value <= 1 && value >= 0) ? callback() : callback(new Error());
                }
                callback(new Error());
            }
            function checkValueIsNotZero (rule, value, callback) {
                if (value === '' || value == 0) {
                    callback(new Error());
                }
                callback();
            }
            return{
                form:{
                    name: '',
                    nominal_power: '',
                    description: '',
                    nominal_voltage: '',
                    nominal_current: '',
                    cos_phi: '',
                    nominal_speed: '',
                    annual_working_time: '',
                    casing_type: '',
                    application_type: '',
                    regulation_type: '',
                    archived: false,
                    trained_machine: {
                        type: 'power',
                        pressure: 0,
                        pressure_unit: '',
                        flow: 0,
                        flow_unit: '',
                        efficiency: '',
                        pn_me: '',
                    }
                },
                rules: {
                    name: {
                        required: true,
                        message: 'Le nom du moteur est requis',
                        trigger: 'blur'
                    },
                    nominal_power: {
                        required: true,
                        validator: checkNominalPower,
                        message: 'La valeur doit être comprise entre 1 et 9999 kW',
                        trigger: 'blur'
                    },
                    nominal_voltage: {
                        required: true,
                        validator: checkNominalVoltage,
                        message: 'La valeur doit être comprise entre 380 et 400 V',
                        trigger: 'blur'
                    },
                    nominal_current: {
                        required: true,
                        validator: checkNominalIntensity,
                        message: 'La valeur doit être comprise entre 3 et 2000 A',
                        trigger: 'blur'
                    },
                    cos_phi: {
                        required: true,
                        validator: checkCosPhi,
                        message: 'La valeur doit être comprise entre 0,6 et 0,95',
                        trigger: 'blur'
                    },
                    nominal_speed: {
                        required: true,
                        validator: checkNominalSpeed,
                        message: 'La valeur doit être comprise entre 1400 et 1500 tr/min, 2900 et 2999 tr/min',
                        trigger: 'blur'
                    },
                    annual_working_time: {
                        required: true,
                        trigger: 'blur',
                        validator: checkWorkingTime,
                        message: 'La valeur doit être comprise entre 0 et 8760',
                    },
                    casing_type: [{required: true, message:'Type de structure requis', trigger: 'blur'}],
                    application_type: [{required: true, message:'Type d\'application requis', trigger: 'blur'}],
                    regulation_type: [{required: true, message:'Type de régulation requis', trigger: 'blur'}],
                    'trained_machine.pressure': [{required: true, validator: checkValueIsNotZero, message:'La valeur doit être supérieure à 0', trigger: 'blur'}],
                    'trained_machine.pressure_unit': [{required: true, message:'Unité de pression requise', trigger: 'blur'}],
                    'trained_machine.flow': [{required: true, validator: checkValueIsNotZero, message:'La valeur doit être supérieure à 0', trigger: 'blur'}],
                    'trained_machine.flow_unit': [{required: true, message:'Unité de débit requis', trigger: 'blur'}],
                    'trained_machine.efficiency': [{required: true, validator: checkEfficiency, message:'La valeur doit être comprise entre 0 et 1', trigger: 'blur'}],
                    'trained_machine.pn_me': [{required: true, validator: checkValueIsNotZero, message:'La valeur doit être supérieure à 0', trigger: 'blur'}],
                },
                displayPriceModal: false,
                relatedSite: null,
                loading: false,
                motorMode: 'simple',
                motor: null,
            }
        },
        computed:{
            ...mapGetters([
                'currentSite', 
                'applicationMode'
            ]),
            pageTitle() {
                return this.form.name ? this.form.name : '';
            },
            isEdit(){
                return this.$route.params.motorUid;
            },
            currentMode(){
                if(this.isEdit){
                    return this.motorMode;
                }
                return this.applicationMode
            },
            toLoad(){
                if(this.$route.params.motorUid){
                    return [
                        {
                            model: 'motors',
                            name: 'motors',
                            filters:{
                                uid: this.$route.params.motorUid
                            }
                        }
                    ];
                }
                return [];
            },
            isEdit(){
                return this.$route.params.motorUid ? true : false;
            },
            isAdvanced(){
                return this.currentMode === 'advanced'
            },
            tooltipContent(){
                if(this.isAdvanced){
                    return 'Avec calcul des économies d’énergies'
                }
                return 'Sans calcul des économies d’énergies'
            },
            siteMwhPriceExist(){
                return this.currentSite.mwh_price && this.currentSite.mwh_price > 0;
            }
        },
        mounted(){
            if(!this.siteMwhPriceExist && this.applicationMode === 'advanced'){
                this.relatedSite = this.currentSite;
                this.displayPriceModal = true;
            }
        },
        methods: {
            onDataFetched(res){
                if(res.motors){
                    this.$set(this, 'motor', res.motors[0]);
                    this.$set(this, 'motorMode', this.motor.mode);
                    this.setForm();
                }
            },
            setForm(){
                this.updateFormFromMotor(this.form, this.motor)
            },
            updateFormFromMotor(form, motor) {
                Object.keys(form).forEach(key => {
                    if (key in motor) {
                        if (typeof form[key] === 'object' && !Array.isArray(form[key])) {
                            // Recursively handle nested objects
                            this.updateFormFromMotor(form[key], motor[key]);
                        } else {
                            form[key] = motor[key];
                        }
                    }
                });
            },
            showMessage(el) {
                if (this.form[el].length)
                    return true;
                return false;
            },
            updateApplicationMode(mode){
                this.$set(this, 'motorMode', mode);
                this.$store.dispatch('updateApplicationMode', mode);
            },
            closePriceModal(mode){
                if(mode !== ''){
                    this.updateApplicationMode(mode)
                }
                this.displayPriceModal = false;
            },
            beforeModeUpdate(){
                if(this.isAdvanced){
                    this.updateApplicationMode('simple')
                    
                }else{
                    if(this.currentSite === ''){
                        this.relatedSite = null
                        this.displayPriceModal = true;
                    }else{
                        this.relatedSite = this.currentSite;
                        if(this.relatedSite.mwh_price && this.relatedSite.mwh_price > 0){
                            this.updateApplicationMode('advanced')
                        }else{
                            this.displayPriceModal = true;
                        }
                    }
                }
            },
            cancel(){
                this.$router.go(-1);
            },
            saveEngine() {
                this.$refs.form.validate(valid => {
                    if(valid){
                        this.loading = true;
                        let method = this.isEdit?'patchItem':'createItem';
                        let newMotor = {
                            item: {...this.form},
                            model: 'motors'
                        };
                        if (this.isEdit) {
                            newMotor.item.uid = this.motor.uid;
                            newMotor.item.url = this.motor.url;
                            newMotor.item['mode'] = this.motorMode;
                        }else {
                            newMotor.item['mode'] = this.applicationMode;
                            newMotor.item['site_uid'] = this.currentSite.uid;
                            newMotor.url = this.$store.state.api.meta.listModels.motors.url;
                        }
                        this.$store.dispatch(method, newMotor).then(() => {
                            if (method === 'patchItem') {
                                this.$notify({
                                    type: 'success',
                                    title: 'Succès',
                                    message: 'Moteur correctement modifié'
                                });
                            }
                            else {
                                this.$notify({
                                    type: 'success',
                                    title: 'Succès',
                                    message: 'Moteur correctement crée'
                                });
                            }
                            this.loading = false;
                            this.$router.push({ name: 'Home' });
                        }).catch(() => {
                            this.$notify({
                                type: 'error',
                                title: 'Erreur',
                            });
                            this.loading = false;
                        });
                    }else{
                        return;
                    }
                })
            }
        },
    }
</script>

<style lang="scss">
    .page-title {
        background-color: #409EFF;
        height: 7em;
        color: white;
    }
    .advanced-form-container{
        margin: 0 2rem;
        .moteurForm{
            .top{
                margin-bottom: 20px !important;
                .el-row{
                    display: flex;
                    align-items: end;
                    .mode-switch{
                        text-align: center;
                        margin-bottom: 22px;
                        display: flex;
                        align-items: center;
                        gap: 1rem;
                        .switch-labels{
                            display: flex;
                            flex-direction: column;
                            &.inactive-label{
                                text-align: right;
                                &.is-active{
                                    .label-title{
                                        color: #409EFF
                                    }
                                }
                            }
                            &.active-label{
                                text-align: left;
                                &.is-active{
                                    .label-title{
                                        color: #409EFF
                                    }
                                }

                            }
                            .label-title{
                                font-weight: 600;
                            }
                            .label-descr{
                                font-size: 12px;
                            }

                        }
                    }
                }
            }
            .el-form-item {
                width: 100%;
                label {
                    margin-top: 20px;
                    padding: 0;
                    height: 30px;
                }
                input {
                    padding: 0;
                    border-left: none;
                    border-top: none;
                    border-right: none;
                    border-radius: 0;
                    
                    // border-bottom-color: @color-1;
                    &:focus {
                        // border-bottom-color: @color-1 !important;
                        border-width: 1px;
                    }
                }
                input[type=number]{
                    text-align: center;
                }
            }
        }
        .advanced-form-content{
            display: flex;
            gap: 0.5rem;
            .plaque-moteur, .exploitation-moteur{
                flex-basis: 50%;
                padding: 5px 15px 20px;
                border: 5px solid #efefef !important;
                .el-col {
                    max-height: unset;
                }
            }
            .advanced-section{
                flex-basis: 33.3%;
                padding: 1rem;
                .step-title{
                    font-size: 22px;
                    margin: 1rem 0;
                }
                .rowNominalPower {
                    flex-wrap: wrap;
                    position: relative;
                    .el-form-item__content {
                        position: static;
                        .el-row {
                            position: static;
                            .el-radio-group {
                                display: flex;
                                flex-direction: row;
                                flex-wrap: wrap;
                                align-items: center;
                                justify-content: space-around;
                                width: 100%;
                                margin: 20px 0;
                            }
                        }
                    }
                }

            }
        }
    }
    .buttons-container{
        display: flex;
        gap: 1rem;
        justify-content: end;
        margin: 1rem 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/Home/motors/AdvancedMotorForm.vue